/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Notification, Button, Spinner, Typography } from '@telus-uds/components-web';

import { Error } from '../design/elements';
import RichText from '../richText';
import FormStep from './formStep';
import FormStepContactCentre from './formStepContactCentre';
import FormStepBusinessApp from './formStepBusinessApp';
import FormStepIoT from './formStepIoT';

import { FormWrapper, FormTitle } from './css';
import submitPayload, { isEligibilityForm } from './formSubmitLogic';
import {
  businessConnectContactCentreOnlineTool,
  businessConnectContactCentreLandingPage,
  businessConnectQuoteToolForm,
  orderDetailsForm,
  fieldMultisiteOrder,
  fieldNumberOfMultiSites,
  multisiteUniqueFields,
  orderStatus,
  quoteStatus,
  businessAppsCategoryName,
  constactCentreCategoryName,
  businessAppsOrderForm,
  iotCategoryName,
  iotOrderForm,
  iotPrequalificationForm,
  businessAppsPrequalificationForm,
  fieldIotActivationOrRenwal,
  fieldIotProductSelected,
  fieldRecontractCustomer,
  isBusinessConnectQuoteTool,
  fieldWLSBusinessConnect,
  fieldIsThisAnEContractCustomer,
  filedNeedMoreThanSingleServiceAddress,
  filedNeedMediaAdvertisingBilling,
  fieldStarterSeat
} from '../utils/constant';
import request, {
  isAdmin,
  isProposalHouse,
  isOrderFulfillmentTeam,
  isSalesSupport,
  isSalesManager,
  isSalesRep,
  canSubmitOrders
} from '../utils/request';
import { getPathVariables } from '../misc';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import {
  viewPDF,
  viewDocx,
  movedToQuoteApproved,
  sendToSRT,
  submitForApproval,
  onSave,
  onSaveAndExit,
  onOrderCancelled,
  onCallcentreFormSubmit,
  onBusinessAppsFormSubmit
} from './utils/formActions';
import Dashboards from './dashboards';
import ConfirmationBox from '../design/shared/ConfirmationBox';

const Form = ({ data, orderId, history, initialStep }) => {
  if (!data) return <Error text="Error!" />;
  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: {
      yes,
      no,
      valueGeotab,
      valueFleetcomplete,
      valueRaven,
      valueNorthStarSystems,
      valueNorthStarSystemsFarmAndRanch,
      valueFillipFleet,
      valuePowerFleet,
      valueGeoforce,
      valueActivation,
      valueRenewal,
      valueYesLookingToAddSeats
    },
    iotOrderDetailsSection: {
      submitSuccessHeading,
      submitSuccessText,
      labelStartNewOrder
    }
  } = localizedStrings;

  const {
    fields: { description, steps, skipIntro, hideProgressBar, showOrdersList }
  } = data;
  console.log(description, 'description');
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState();
  const [orderData, setOrderData] = useState();
  const [eligible, setEligible] = useState({
    isEligible: false,
    note: {}
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const stableOrderData = useMemo(() => orderData || {}, [orderData]);
  const {
    location: { pathname }
  } = history;
  const [locale, categoryName, formName] = getPathVariables(pathname);

  const isMultisiteOrder = _.get(orderData, fieldMultisiteOrder, '') === yes;
  const totalNumberOfMultisites = +_.get(orderData, fieldNumberOfMultiSites, 0);
  const currentSite = _.get(orderData, 'currentSite', 1);
  let isSalesRepSectionVisible = false;
  // SOF-3356 R-006 / FR-006: SMs with `canSubmitOrders === true` must render
  // the FormStep shell so they can reach the Prequalification section and
  // the "New Order" CTA. SMs without order-create access do NOT need
  // FormStep — the `<Dashboards>` component below is rendered independently
  // of this gate and provides the My Orders / Order Fulfillment listing
  // tabs (Phase 9 T054). Restoring the SM-with-canSubmitOrders branch
  // (regression fix 2026-05-05): omitting it suppresses the New Order CTA
  // for ALL SMs, not just listing-only ones.
  const smCanCreateOrders = isSalesManager && canSubmitOrders();
  if (formName === businessAppsPrequalificationForm) {
    isSalesRepSectionVisible = isAdmin || isSalesRep || smCanCreateOrders;
  } else {
    isSalesRepSectionVisible =
      isAdmin || isSalesRep || isSalesSupport || smCanCreateOrders;
  }

  const updateStep = newStep => {
    setStep(newStep);
  };

  useEffect(() => {
    // SOF-3356 Phase 9 T054: SMs without order-create access have no
    // prequalification step to fill out — skip the BCx intro so they land
    // directly on step 1 where the SOV / My Orders dashboards render.
    const skipIntroForListingOnlySm =
      isSalesManager && !canSubmitOrders() && formName === businessConnectQuoteToolForm;
    const effectiveSkipIntro = skipIntro || skipIntroForListingOnlySm;
    const newStep = (initialStep && Number(initialStep)) || (effectiveSkipIntro ? 1 : 0);
    setStep(newStep);
  }, [initialStep]);

  useEffect(() => {
    if (orderId) {
      request.get(`/orders/${orderId}`).then(response => {
        if (response.data) {
          setOrderData(response.data);
          setLoading(false);
        }
      });
    } else setLoading(false);
  }, [orderId, initialStep]);

  const showNewOrder = isEligibilityForm();

  const removeMultiSiteUniqueKeys = formData => {
    const updatedOrderData = { ...orderData, ...formData };
    updatedOrderData.currentSite = currentSite + 1;
    updatedOrderData.quoteStatus = quoteStatus.incomplete;

    if (isMultisiteOrder === true) {
      const availablePromo = _.get(orderData, 'availableNewpromo', []);
      updatedOrderData.availableNewpromo = updatedOrderData.availableDiscountsAndPromotions
        ? updatedOrderData.availableDiscountsAndPromotions
        : availablePromo;
      multisiteUniqueFields.forEach(key => {
        delete updatedOrderData[key];
      });
    } else {
      multisiteUniqueFields.forEach(key => {
        delete updatedOrderData[key];
      });
    }
    return updatedOrderData;
  };
  const moveToNextSite = formData => {
    const newOrderData = removeMultiSiteUniqueKeys(formData);
    request.post('/orders', { ...newOrderData }).then(resp => {
      if (resp.data) {
        const {
          data: { id }
        } = resp;
        setOrderData(data);
        history.push({
          pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
          search: `?orderId=${id}&step=1`
        });
      }
    });
  };

  const createNewOrder = (type, formLink, formData = {}) => {
    const salesRepInfoForSRT = JSON.parse(
      localStorage.getItem('salesRepInfoForSRT')
    );
    const profile =
      type === 'BA' && salesRepInfoForSRT
        ? salesRepInfoForSRT
        : request.getProfile();

    delete profile.id;
    delete profile.province;
    delete profile.status;
    delete profile.createdAt;
    delete profile.updatedAt;
    const payload = {
      ...profile,
      ...formData,
      status: orderStatus.incomplete,
      type,
      locale,
      categoryName,
      formName
    };
    request.post('/orders', payload).then(resp => {
      if (resp.data) {
        const {
          data: { id }
        } = resp;
        setOrderData(data);
        setStep(step + 1);
        history.push({
          pathname: `/${locale}/${categoryName}/${formLink}`,
          search: `?orderId=${id}`
        });
      }
    }
  );
  };

  // Finish the flow
  const onFormSubmit = async formData => {
    let isOdysseyValues;
    let isThisOdysseyAI;
  if(formName === isBusinessConnectQuoteTool){

    let  profile = request.getProfile();
    const { channelName, channels = [] } =
    (typeof profile !== 'undefined' && profile) || {};

    isOdysseyValues = (formData.wlsBusinessConnect === no &&
    formData.needMoreThanSingleServiceAddress === no &&
    // formData.needBilledDirectoryListing === no &&
    formData.isThisAnEContractCustomer === no &&
    formData.needMediaAdvertisingBilling === no &&
    (formData.recontractCustomer === no || channelName === "Dealer")) ? yes : no;
    isThisOdysseyAI =
      formData.customerRequireAIFeatures === yes &&
      (formData.vulcanOrder === yes ||
       (formData.vulcanOrder === no &&
        (formData.recontractCustomer === no || channelName === 'Dealer') &&
        formData.coperToFibreMigration === no &&
        formData.migrationGoco === no))
        ? yes
        : no;
    if (formData.migrationGoco === yes) {
      formData.customerRequireAIFeatures = undefined;
    }
  }
    const searchString = (paramStep, id = '') => {
      return orderData && orderData.id
        ? `?orderId=${orderData.id}&step=${paramStep}`
        : `?orderId=${id}&step=${paramStep}`;
    };

    // Send order data to API
    const response = await submitPayload(
      {
        ...orderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step,
        ...(formName === isBusinessConnectQuoteTool && {
          isOdysseyValues,
          isThisOdysseyAI
        })
      },
      step,
      isMultisiteOrder,
      currentSite,
      totalNumberOfMultisites,
      orderData,
      orderStatus,
      steps
    );

    setOrderData({ ...orderData, ...response.data });
    if (response) {
      if (formName === orderDetailsForm && step === 7) {
        updateStep(0);
        setEligible({ isEligible: false, note: {} });
        setOrderData();

        history.push({
          pathname: `/${locale}/${categoryName}/${businessConnectQuoteToolForm}`
        });
      } else {
        if (
          isMultisiteOrder &&
          step === steps.length - 1 &&
          currentSite !== totalNumberOfMultisites &&
          _.get(orderData, 'status', orderStatus.incomplete) !==
            orderStatus.waitingOnSales
        ) {
          moveToNextSite(formData);
          return;
        }
        let newStep = formName === orderDetailsForm ? step + 1 : step;
        const valueRecontract = _.get(orderData, 'recontractCustomer', '');
        const valueStarterSeat = _.get(formData, fieldStarterSeat, '');
        const customerAddedSeats = _.get(orderData, 'recontractSeatsCustomerAdding', '0');
        const valueWLSBusinessConnect = _.get(orderData, fieldWLSBusinessConnect, []);
      const valueIsEContractCustomer = _.get(orderData, fieldIsThisAnEContractCustomer, []);
      const valueNeedMoreThanSingleServiceAddress = _.get(orderData, filedNeedMoreThanSingleServiceAddress, []);
      const valueNeedMediaAdvertisingBilling = _.get(orderData, filedNeedMediaAdvertisingBilling, []);
      const isThisOdysseyAIOrder = _.get(orderData, 'isThisOdysseyAI','') === yes;
      const isAllValuesNoOdyssey = [
        valueIsEContractCustomer,
        valueNeedMoreThanSingleServiceAddress,
        valueNeedMediaAdvertisingBilling,
        valueWLSBusinessConnect
      ].every(value => value === no);
      
        if (valueRecontract === yes && formName === orderDetailsForm) {
          const valueRecontractAddSubtractSeats = _.get(
            response,
            'data.recontractAddSubtractSeats',
            ''
          );
          if (step === 1) {
            newStep = 4;
            if (valueRecontractAddSubtractSeats === valueYesLookingToAddSeats)
              newStep = 3;
          }

          if (step === 4 && customerAddedSeats <= 0) {
            newStep = 7;
          }
          if (step === 4 && customerAddedSeats > 0) {
            newStep = 5;
          }
          if (step === 5) newStep = 7;

          // if (
          //   step === 5 &&
          //   valueRecontractAddSubtractSeats !== valueYesLookingToAddSeats
          // )
          //   newStep = 7;
        }
        if(isAllValuesNoOdyssey || isThisOdysseyAIOrder){
          if((step === 1 && valueStarterSeat <= 0) || (step === 2)){
            newStep = 4;
          }
        }
        updateStep(newStep);
        history.push({
          pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
          search: searchString(newStep, response.data.id)
        });
      }
    }
  };
  const onIoTFormSubmit = async formData => {
    setLoading(true);
    try {
      const payload = {
        ...orderData,
        ...formData,
        status: orderStatus.pendingValidation
      };
      if (payload.channels && payload.channels.length) {
        payload.channelId = payload.channels[0].id;
      }
      if (payload.iotCompanyName) {
        payload.legalBusinessName_businessPersonal = payload.iotCompanyName;
      }
      if (payload.iotPreferredLanguage) {
        payload.languageOfActivation = payload.iotPreferredLanguage;
      }
      const { id } = orderData;
      const result = await request.put(`/orders/${id}`, payload);
      if (result) {
        setLoading(false);
        setShowConfirmation(true);
        setRedirectUrl(
          `/${locale}/${iotCategoryName}/${iotPrequalificationForm}`
        );
      }
    } catch (err) {
      // .. Handle Error
    }
  };

  const prevStep = e => {
    e.preventDefault();
    let newStep = step - 1;

    const valueRecontract = _.get(orderData, 'recontractCustomer', '');
    const customerAddedSeats = _.get(orderData, 'recontractSeatsCustomerAdding', '0');
        const valueStarterSeat = _.get(orderData, fieldStarterSeat, '');
        const valueWLSBusinessConnect = _.get(orderData, fieldWLSBusinessConnect, []);
      const valueIsEContractCustomer = _.get(orderData, fieldIsThisAnEContractCustomer, []);
      const valueNeedMoreThanSingleServiceAddress = _.get(orderData, filedNeedMoreThanSingleServiceAddress, []);
      const valueNeedMediaAdvertisingBilling = _.get(orderData, filedNeedMediaAdvertisingBilling, []);
      const isAllValuesNoOdyssey = [
        valueIsEContractCustomer,
        valueNeedMoreThanSingleServiceAddress,
        valueNeedMediaAdvertisingBilling,
        valueWLSBusinessConnect
      ].every(value => value === no);

    const isThisOdysseyAIOrder = _.get(orderData, 'isThisOdysseyAI','') === yes;

    if (valueRecontract === yes) {
      const valueRecontractAddSubtractSeats = _.get(
        orderData,
        'recontractAddSubtractSeats',
        ''
      );
      if (
        formName === orderDetailsForm &&
        step === 4 &&
        valueRecontractAddSubtractSeats === valueYesLookingToAddSeats
      )
        newStep = 3;
      if (
        (formName === orderDetailsForm &&
          step === 4 &&
          valueRecontractAddSubtractSeats !== valueYesLookingToAddSeats) ||
        step === 3
      )
        newStep = 1;
      if (formName === orderDetailsForm && step === 7) newStep = 4;
      if (formName === orderDetailsForm && step === 7 && customerAddedSeats > 0) newStep = 5;
      // if (
      //   formName === orderDetailsForm &&
      //   step === 7 &&
      //   valueRecontractAddSubtractSeats !== valueYesLookingToAddSeats
      // )
      //   newStep = 5;
    }
    if(isAllValuesNoOdyssey || isThisOdysseyAIOrder){
      if((step === 4 && valueStarterSeat <= 0)){
        newStep = 1;
      }
      if((step === 4 && valueStarterSeat > 0)){
        newStep = 2;
      }
    }
    updateStep(newStep);
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: `?orderId=${orderData.id}&step=${newStep}`
    });
  };

  const prevStepBusinessOrderForm = e => {
    e.preventDefault();
    updateStep(step - 1);
    history.push({
      pathname: `/${locale}/${categoryName}/${businessAppsOrderForm}`,
      search: `?orderId=${orderData.id}&step=${step - 1}`
    });
  };

  const navigateToContactCentreHomePage = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${businessConnectContactCentreLandingPage}`
    });
  };

  const onRedirectUser = () => {
    if (!redirectUrl) return;
    setShowConfirmation(false);
    history.push({
      pathname: redirectUrl
    });
    window.location.reload();
  };

  const navigateToBusinessAppHomePage = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${businessAppsPrequalificationForm}`
    });
    window.location.reload();
  };

  /**
   * @returns all available dashboards
   * for the currently logged in user
   */
  const getAvailableDashboard = () => {
    const dashboards = [];
    /** Sales Rep Dashboard for Role Admin/Sales Rep/Sales Manager/Sales Support */
    // SOF-3356 Phase 9 T054: SMs see listing tabs unconditionally; create
    // gating is handled by the prequal section + "New Order" CTA gates.
    if (
      formName === businessConnectQuoteToolForm &&
      step === 1 &&
      showOrdersList &&
      !isOrderFulfillmentTeam &&
      !isProposalHouse
    )
      dashboards.push('SALES_REP_DASHBOARD');

    /** Call centre Sales Rep Dashboard for Role Admin/Sales Rep */
    if (formName === businessConnectContactCentreLandingPage)
      dashboards.push('CC_SALES_REP_DASHBOARD');

    /** IoT Sales Rep Dashboard for Role Admin/Sales Rep/Sales Manager (T054) */
    if (
      formName === iotPrequalificationForm &&
      !isOrderFulfillmentTeam &&
      !isProposalHouse
    )
      dashboards.push('IOT_SALES_REP_DASHBOARD');
    /** IoT Order Fulfillment Dashboard */
    if (
      formName === iotPrequalificationForm &&
      (isOrderFulfillmentTeam || isAdmin || isSalesSupport || isSalesManager)
    )
      dashboards.push('IOT_SOV_DASHBOARD');

    /** SOV Dashboard for Role Admin/Order Fulfillment/Sales Manager (T054) */
    if (
      formName === businessConnectQuoteToolForm &&
      step === 1 &&
      showOrdersList &&
      (isOrderFulfillmentTeam || isAdmin || isSalesSupport || isSalesManager)
    )
      dashboards.push('SOV_DASHBOARD');

    /** Quote Approval Dashboard for Role Admin/Proposal House */
    if (
      formName === businessConnectQuoteToolForm &&
      step === 1 &&
      showOrdersList &&
      (isProposalHouse || isAdmin)
    )
      dashboards.push('QUOTE_APPROVAL_DASHBOARD');

    /** Business Apps Dashboard (My Orders tile). */
    // SOF-3356 Phase 9 T054 follow-up (2026-05-05): Sales Managers were
    // missing from this gate, so SMs saw the BA OFD tab but not the BA
    // "My Orders" tile. Mirrors the wireline `SALES_REP_DASHBOARD` gate
    // (which already includes SMs unconditionally per T054).
    if (
      formName === businessAppsPrequalificationForm &&
      (isAdmin || isSalesRep || isSalesManager)
    )
      dashboards.push('BA_SALES_REP_DASHBOARD');

    if (
      formName === businessAppsPrequalificationForm &&
      step === 0 &&
      showOrdersList &&
      (isOrderFulfillmentTeam || isAdmin || isSalesManager || isSalesSupport)
    )
      dashboards.push('BA_ORDER_FULFILLMENT_DASHBOARD');

    return dashboards;
  };

  useEffect(() => {
    if (orderData) {
      const valueRecontractFlow = _.get(orderData, fieldRecontractCustomer, '');
      if (valueRecontractFlow === yes) {
        const valueRecontractAddSubtractSeats = _.get(
          orderData,
          'recontractAddSubtractSeats',
          ''
        );
        if (
          valueRecontractAddSubtractSeats === valueYesLookingToAddSeats &&
          step === 2
        ) {
          setStep(3);
        }
        if (
          valueRecontractAddSubtractSeats !== valueYesLookingToAddSeats &&
          [2, 3].includes(step)
        )
          setStep(4);
      }
    }
  }, [orderData]);

  const getIoTFormStep = () => {
    if (formName === iotOrderForm) {
      const product = _.get(orderData, fieldIotProductSelected, '');
      const type = _.get(orderData, fieldIotActivationOrRenwal, '');

      if (product === valueGeotab && type === valueActivation) return steps[0];
      if (product === valueGeotab && type === valueRenewal) return steps[1];
      if (product === valueFleetcomplete && type === valueActivation)
        return steps[2];
      if (product === valueFleetcomplete && type === valueRenewal)
        return steps[3];
      if (product === valueRaven) return steps[4];
      if (product === valueNorthStarSystems) return steps[5];
      if (product === valueNorthStarSystemsFarmAndRanch) return steps[6];
      if (product === valueFillipFleet) return steps[7];
      if (product === valuePowerFleet) return steps[8];
      if (product === valueGeoforce && type === valueActivation) return steps[9];
      if (product === valueGeoforce && type === valueRenewal) return steps[10];
    }
    return steps[0];
  };

  const getFormStep = () => {
    if (categoryName === iotCategoryName)
      return (
        <FormStepIoT
          key={`formstep-${step}`}
          stepData={getIoTFormStep()}
          orderData={stableOrderData}
          steps={steps}
          step={step}
          setEligible={setEligible}
          eligible={eligible}
          history={history}
          setOrderData={setOrderData}
          onSaveAndExit={fields =>
            onSaveAndExit(fields, orderData, step, history, setLoading, locale)
          }
          onFormSubmit={onIoTFormSubmit}
          createNewIotOrder={formData =>
            createNewOrder('IOT', iotOrderForm, formData)
          }
          formName={formName}
          navigateToContactCentreHomePage={navigateToContactCentreHomePage}
        />
      );
    if (categoryName === businessAppsCategoryName)
      return (
        <FormStepBusinessApp
          key={`formstep-${step}`}
          stepData={steps[step - 1] ? steps[step - 1] : steps[0]}
          orderData={orderData}
          steps={steps}
          step={step}
          onViewDocx={fields => {
            viewDocx(orderData);
            movedToQuoteApproved(fields, orderData).then(() => {
              navigateToBusinessAppHomePage();
            });
          }}
          setEligible={setEligible}
          eligible={eligible}
          history={history}
          prevStep={prevStepBusinessOrderForm}
          onCancel={() => {
            onOrderCancelled(orderData);
            navigateToBusinessAppHomePage();
          }}
          setOrderData={setOrderData}
          onSaveAndExit={fields =>
            onSaveAndExit(fields, orderData, step, history, setLoading, locale)
          }
          onFormSubmit={ordrData =>
            onBusinessAppsFormSubmit(
              ordrData,
              locale,
              categoryName,
              formName,
              step,
              setOrderData,
              updateStep,
              history
            )
          }
          createNewBusinessAppOrder={formData =>
            createNewOrder('BA', businessAppsOrderForm, formData)
          }
          formName={formName}
          navigateToContactCentreHomePage={navigateToContactCentreHomePage}
        />
      );
    if (categoryName === constactCentreCategoryName)
      return (
        <FormStepContactCentre
          key={`formstep-${step}`}
          stepData={steps[0]}
          orderData={orderData}
          setOrderData={setOrderData}
          onSaveAndExit={fields =>
            onSaveAndExit(fields, orderData, step, history, setLoading, locale)
          }
          onFormSubmit={onCallcentreFormSubmit}
          createNewContactOrder={() =>
            createNewOrder('CC', businessConnectContactCentreOnlineTool)
          }
          formName={formName}
          navigateToContactCentreHomePage={navigateToContactCentreHomePage}
        />
      );
    return (
      <FormStep
        key={`formstep-${step}`}
        stepData={steps[step - 1]}
        steps={steps}
        step={step}
        setEligible={setEligible}
        eligible={eligible}
        updateStep={updateStep}
        history={history}
        orderData={orderData}
        onSaveAndExit={fields =>
          onSaveAndExit(fields, orderData, step, history, setLoading, locale)
        }
        onSave={fields => onSave(fields, orderData)}
        onViewPdf={() => viewPDF(locale, orderData)}
        sendToSRT={fields => sendToSRT(fields, orderData)}
        submitForApproval={fields => submitForApproval(fields, orderData)}
        onFormSubmit={onFormSubmit}
        hideProgressBar={hideProgressBar}
        showNewOrder={showNewOrder}
        setOrderData={setOrderData}
        formName={formName}
        prevStep={prevStep}
        currentSite={currentSite}
        isMultisiteOrder={isMultisiteOrder}
        totalNumberOfMultisites={totalNumberOfMultisites}
      />
    );
  };

  return (
    <>
      <Spinner fullScreen label="Loading page..." show={loading} />
      {[
        businessConnectQuoteToolForm,
        businessAppsPrequalificationForm,
        iotPrequalificationForm
      ].includes(formName) && (
        <div className="container 85%">
          <div id="title">
            <div id="title-wrapper">
              <div style={{ padding: '2rem 0 0 0', fontWeight: 'bold' }}>
                  <RichText data={description} />
              </div>
            </div>
          </div>
        </div>
      )}
      {!(formName === orderDetailsForm || isSalesRepSectionVisible) &&
        categoryName === businessAppsCategoryName && (
          <FormTitle>{steps[0].fields.name}</FormTitle>
        )}
      {(formName === orderDetailsForm || isSalesRepSectionVisible) && (
        <div className="container 85%">
          <div id="introduction">
            <div id="introduction-wrapper">
              <FormWrapper>
                {([
                  businessConnectQuoteToolForm,
                  businessConnectContactCentreLandingPage,
                  businessAppsPrequalificationForm,
                  iotPrequalificationForm
                ].includes(formName) ||
                  (orderData && orderData.id)) &&
                  getFormStep()}
                {eligible.note && eligible.note.content && (
                  <div style={{ width: '100%', flexBasis: '100%', marginTop: '1.5rem' }}>
                    <Notification variant={{ validation: 'error' }}>
                      <Typography>
                        <RichText data={eligible.note} />
                      </Typography>
                    </Notification>
                  </div>
                )}
              </FormWrapper>
            </div>
          </div>
        </div>
      )}

      <Dashboards
        availableDashboards={getAvailableDashboard()}
        location={history.location}
      />
      <ConfirmationBox
        open={showConfirmation}
        hideCloseButton
        setOpen
        header={submitSuccessHeading}
        onClose={() => setShowConfirmation(false)}
      >
        <p>{submitSuccessText}</p>
        <div style={{ display: 'flex', marginTop: '1rem' }}>
          <Button onPress={onRedirectUser}>{labelStartNewOrder}</Button>
        </div>
      </ConfirmationBox>
    </>
  );
};

Form.propTypes = {
  data: PropTypes.shape({
    fields: PropTypes.shape({
      description: PropTypes.string,
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          fields: PropTypes.shape({
            name: PropTypes.string
          })
        })
      ),
      skipIntro: PropTypes.bool,
      hideProgressBar: PropTypes.bool,
      showOrdersList: PropTypes.bool
    })
  }).isRequired,
  orderId: PropTypes.string,
  initialStep: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string
    })
  }).isRequired
};

Form.defaultProps = {
  orderId: '',
  initialStep: ''
};

export default Form;
